<template>
  <div>
    <!--审核中-->
    <div v-if="is_developer===2" class="audit">
      <div class="audit-tip">您的开发者申请已提交审核！</div>
      <div class="audit-tip">审核完成后，我们将第一时间通知您。</div>
    </div>
    <!--审核中-->
    <!--我的应用-->
    <div v-else-if="is_developer===1">
      <Application></Application>
    </div>
    <!--我的应用-->
    <!--申请成为开发者-->
    <div v-else-if="is_developer===0">
      <Apply @onSuccess="changeStatus"></Apply>
    </div>
    <!--申请成为开发者-->
  </div>
</template>
<script>
import Apply from './Apply'
import Application from './Application'
import { getUserInfo } from '@/api/user'
export default {
  name: 'DocumentUserApply',
  components: {
    Apply,
    Application
  },
  computed: {
    is_developer(){
      return this.$store.getters.userInfo.is_developer
    }
  },
  created: function () {
    this.$store.dispatch('user/getInfo')
  },
  methods: {
    changeStatus (val){
      this.is_developer = val
    }
  }
}
</script>
<style scoped>
.audit{
  margin: 30px 50px;
}
.audit .audit-tip{
  line-height: 40px;
  color: #FF6600;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/user/index.vue